import { render } from "./MenuTableShow.vue?vue&type=template&id=40294a96"
import script from "./MenuTableShow.vue?vue&type=script&lang=js"
export * from "./MenuTableShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__